import * as React from 'react';
import styled from "styled-components";
import Assets from "../../../assets/img/assets";
import HeadlineMiddle from "../../../common/atom/text/headline_middle";
import OuterLink from "../../../common/atom/outer_link";
import {OuterURL} from "../../../../config/view_const/outer_url";
import Paragraph from "../../../common/atom/text/paragraph";
import {ConstBreakPoint, ConstColor, ConstZIndex} from "../../../../config/styles_const/styles_const";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";

interface IProps {
}

export const CustomerProjectsOverlayNotice: React.FC<IProps> = (props) => {

    return(
            <OverlayWrapper>
                <ScrollWrapper>
                    <TitleWrapper>
                        <HeadlineMiddle>
                            サービス利用には、登録面談が必要です
                        </HeadlineMiddle>
                    </TitleWrapper>

                    <MainContentsWrapper>
                        <Content>
                            <ImgWrapper>
                                <Img src={Assets.tutorial3_01} />
                            </ImgWrapper>
                            <ContentTitleWrapper>
                                <Paragraph bold={true}>
                                    EXPERT NETWORKご登録面談の予約
                                </Paragraph>
                            </ContentTitleWrapper>
                            <ContentTitleBody>
                                <Paragraph>
                                    下記のリンクより面談の予約をお願い致します。
                                </Paragraph>
                                <Paragraph>
                                    オンラインでの面談も承っておりますので、ご希望の際はオンライン面談をご指定下さい。
                                </Paragraph>
                                <Paragraph>
                                    平日夕方以降の面談、土日も対応可能です。
                                </Paragraph>
                            </ContentTitleBody>
                            <OuterLink
                                id={"calendly_link"}
                                href={OuterURL.calendlyURL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <BtnCorporateLarge as={"span"} widthSize={"200px"}>
                                    面談の調整をする
                                </BtnCorporateLarge>
                            </OuterLink>
                        </Content>
                    </MainContentsWrapper>
                </ScrollWrapper>
            </OverlayWrapper>
    )

};

export default CustomerProjectsOverlayNotice;

const OverlayWrapper = styled.div`
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${ConstZIndex.overlay};
    transition: opacity 1s, visibility 1s;
    // background-color: rgba(255, 255, 255, 0.93);
    background-color: ${ConstColor.White};
    @media (min-width: ${ConstBreakPoint.Default}) {
        padding-top: 40px;
    }
`;

// モバイルのスクロール用
const ScrollWrapper = styled.div`
    overflow-y: auto;
    height: calc(100vh - 70px);
    @media (min-width: ${ConstBreakPoint.Default}) {
        height: calc(100vh - 100px);
    }
`;

const TitleWrapper = styled.div`
    text-align: center
    margin-bottom: 50px;
`;

const MainContentsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        flex-direction: row;
    }
`;

const Content = styled.div`
    text-align: center;
    max-width: 330px;
`;

const ContentTitleWrapper = styled.div`
    margin-bottom: 20px;
`;

const ContentTitleBody = styled.div`
    margin-bottom: 40px;
`;

const ImgWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
`;











// WEBPACK FOOTER //
// ./src/presentation/component/customer/projects/customer_projects_overlay_notice.tsx